<template>
  <v-container class="pa-1">
    <v-row no-gutters>
      <v-col cols="12">
        <v-dialog width="1024" v-model="dialog" >
          <template v-slot:activator="{ on }">
             <div class="mb-1">
              <v-row no-gutters>
                <v-col cols="3" offset="8">
                  <v-btn
                    rounded
                    color="error"
                    style="border-radius: 8px;"
                    class="white--text elevation-1"
                    v-on="on"
                  >
                    <span
                    style="font-size: 20px"
                    class="white--text font-weight-bold text-none"
                    >
                      {{ $t('quotes.create_request') }}
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </template>
          <v-card
            style="padding: 5px 40px 20px 40px; border-radius: 10px;"
          >
            <v-card-title
            class="headline font-weight-medium pl-0 pb-4"
            primary-title
            >
              {{ $t('quotes.forwarder_quoting_request') }}
            </v-card-title>
            <v-card-text
              class="pa-0"
            >
              <div v-show="forwardersArray.length > 0" class="quoting--forwarder-list">
                <div class="flex--layout column">
                  <template v-for="({ id, email, company }, index) in forwardersArray">
                      <div :key="id" class="flex--100 mb-3">
                        <div class="flex--layout row">
                            <div
                            :class="{'last-list-item': index === (forwardersArray.length - 1)}"
                            class="flex--40 div--forwader--values">
                            <span class="top--placeholder mb-1">{{ $t('quotes.organization_name') }}</span>
                              {{ `${company.name}` }}
                            </div>
                            <div
                            :class="{'last-list-item': index === (forwardersArray.length - 1)}"
                            class="flex--40 div--forwader--values mb-1">
                            <span class="top--placeholder">{{ $t('quotes.emails') }}</span>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <span
                                    v-on="on"
                                    style="max-width: 100%;"
                                    class="d-inline-block text-truncate"
                                  >
                                      {{ `${email.name.given} ${email.name.family}` }} - {{ email.contacts | userPrimaryEmail }}
                                  </span>
                                </template>
                                <span>
                                  {{ `${email.name.given} ${email.name.family}` }} - {{ email.contacts | userPrimaryEmail }}
                                </span>
                              </v-tooltip>
                            </div>
                          <div class="flex--max-content pl-1">
                            <v-icon @click="handleRemoveForwader(index)" size="18">fa fa-times</v-icon>
                          </div>
                        </div>
                      </div>
                  </template>
                </div>
              </div>
              <div
              class="quoting--card--form">
                <div
                :key="forwarderID"
                class="flex--layout row"
                style="min-height: 75px;"
                >
                  <QuotingAutoComplete
                  class="flex--40"
                  style="margin-right: 10%;"
                  :inputPlaceholder="$tc('quotes.organization', 1)"
                  :inputLabel="$t('quotes.organization_name')"
                  :list="organizations"
                  :value="'Description'"
                  @search="getOrganizations"
                  @selectedEvent="handleSelectCompany"
                  >
                    <!-- <template slot="itemListSlot" slot-scope="{ item }">
                      <span>{{item.name}}</span>
                    </template>
                    <template slot="selectedSlot" slot-scope="{ selected }">
                      <span v-if="selected !== null">{{ selected.name }}</span>
                    </template> -->
                  </QuotingAutoComplete>

                  <QuotingAutoComplete
                  class="flex--40"
                  :inputPlaceholder="$t('quotes.emails')"
                  :list="contacts"
                  :inputDisabled="emailInputDisabled"
                  :value="'Description'"
                  @selectedEvent="handleSelectEmail"
                  >
                  </QuotingAutoComplete>

                   <div v-show="selectedCompany !== null || selectedEmail !== null" style="padding: 26px 0 0 5px;" class="flex--max-content">
                    <v-icon @click="handleEmptyForwarder" size="18">fa fa-times</v-icon>
                  </div>
                </div>
                <!-- <div class="flex--layout row">
                  <div class="flex--100">
                    <v-btn @click="handleAddForwarder" style="border-radius: 4px; letter-spacing: 0;" color="info" class="ml-2">
                      Add Forwarder
                    </v-btn>
                  </div>
                </div> -->
                <div
                :key="transportTypeKey"
                class="flex--layout row"
                >
                  <QuotingAutoComplete
                  class="flex--40"
                  style="margin-right: 10%;"
                  :inputPlaceholder="$t('quotes.transport_type')"
                  :inputLabel="$t('quotes.transport_type')"
                  :list="dropsLength > 1 ? transportTypeForDrops : transportTypes"
                  :value="'text'"
                  @selectedEvent="handleSelectTransportType"
                  :translate="'quotes'"
                  >
                    <!-- <template slot="itemListSlot" slot-scope="{ item }">
                      <span>{{item.name}}</span>
                    </template>
                    <template slot="selectedSlot" slot-scope="{ selected }">
                      <span v-if="selected !== null">{{ selected.name }}</span>
                    </template> -->
                  </QuotingAutoComplete>

                  <QuotingAutoComplete
                  class="flex--40"
                  :inputPlaceholder="$t('quotes.incoterms')"
                  :inputLabel="$t('quotes.incoterms')"
                  :list="selectedTransportType === 'Road' ? incotermsRoadArray : incoterms"
                  :value="'Description'"
                  @selectedEvent="handleSelectIncoterms"
                  >
                  </QuotingAutoComplete>
                  <QuotingManualAddress
                    class="flex--40"
                    @close="handleCloseManualAddress"
                    @address="handleSelectOriginManualAddress"
                    @coordinates="handleSelectOriginManualCoordinates"
                    v-if="isManualAddressVisible"
                  />
                  <QuotingAutoComplete
                  v-if="isOriginPortVisible && !isManualAddressVisible"
                  style="margin-right: 10%;"
                  class="flex--40"
                  :inputPlaceholder="$t('quotes.origin_port_form')"
                  :inputLabel="$t('quotes.origin_port_form')"
                  :list="ports"
                  :value="'Description'"
                  @search="getPorts"
                  @selectedEvent="handleSelectOriginPort"
                  >
                    <template slot="itemListSlot" slot-scope="{ item }">
                      <v-icon
                        size="10"
                        class="mr-1"
                      >
                        {{ handleIconPortType(item.port_type) }}
                      </v-icon>
                      <span> {{ item.Description }}</span>
                    </template>
                    <template slot="itemSelectSlot" slot-scope="{ selected }">
                      <span> {{ selected.Description }}</span>
                    </template>
                  </QuotingAutoComplete>
                  <QuotingAutoComplete
                  v-if="isDestinationPortVisible"
                  class="flex--40"
                  :inputPlaceholder="$t('quotes.destination_port_form')"
                  :inputLabel="$t('quotes.destination_port_form')"
                  :list="ports"
                  :value="'Description'"
                  @search="getPorts"
                  @selectedEvent="handleSelectDestinationPort"
                  >
                    <template slot="itemListSlot" slot-scope="{ item }">
                      <v-icon
                        size="10"
                        class="mr-1"
                      >
                        {{ handleIconPortType(item.port_type) }}
                      </v-icon>
                      <span> {{ item.Description }}</span>
                    </template>
                    <template slot="itemSelectSlot" slot-scope="{ selected }">
                      <span> {{ selected.Description }}</span>
                    </template>
                  </QuotingAutoComplete>
                  <div class="flex--100" >
                    <div class="quoting--textarea--message">
                      <span>{{$t('quotes.message')}}</span>
                      <textarea name="Message" :placeholder="$t('quotes.message')" v-model="quoteRequestMessage" cols="30" rows="5">
                      </textarea>
                    </div>
                  </div>
                </div>
              </div>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
              @click="handleCancelForm"
              text
              >
                <span
                class="wrld_subtitle--text font-weight-medium text-capitalize title">
                  {{ $t('buttons.cancel') }}
                </span>
              </v-btn>
              <v-btn
              rounded
              style="border-radius: 5px;"
              @click="handleSaveForm"
              :disabled="forwardersArray.length < 1 || this.selectedTransportType === null || this.selectedIncoterms === null"
              color="wrld_red">
              <span
              class="primary_text--text font-weight-medium text-capitalize title">
                {{ $t('buttons.send') }}
              </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QuotingAutoComplete from '@/components/shipments/new/quoting/QuotingAutoComplete'
import QuotingManualAddress from '@/components/shipments/new/quoting/QuotingManualAddress'
import { uuid } from 'vue-uuid'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import { filterService, userService, algoliaService, quoteService } from "@/_services"

export default {
  name: 'QuotingRequestForm',
  components: {
    QuotingAutoComplete,
    QuotingManualAddress
  },
  props: {
    transportTypes: Array,
    incoterms: Array
  },
  data () {
    return {
      dialog: false,
      selectedCompany: null,
      emailInputDisabled: true,
      selectedEmail: null,
      selectedTransportType: null,
      selectedIncoterms: null,
      selectedOriginPort: null,
      selectedDestinationPort: null,
      selectedOriginAddress: null,
      selectedDestinationAddress: null,
      selectedOriginCoordinates: null,
      selectedDestinationCoordinates: null,
      forwardersArray: [],
      quoteRequestMessage: '',
      forwarderID: uuid.v4(),
      transportTypeKey: uuid.v1(),
      quoteArray: [],
      request: [],
      organizations: [],
      ports: [],
      contacts: [],
      isManualAddressVisible: false,
      incotermsRoadArray: ['EXW', 'DAP'],
      transportTypeForDrops: [{ text: 'Road'}]
    }
  },
  mounted() {
    this.getOrganizations('')
  },
  computed: {
    ...mapGetters([
      'getShipmentResourceDetails'
    ]),
    ...mapGetters('cognito', ['userAttributes']),
    isOriginPortVisible () {
       switch (this.selectedIncoterms) {
        case 'EXW':
        case 'DPU':
        case 'DAP':
        case 'DDP':
        case 'CFR':
        case 'CIF':
        case 'CPT':
        case 'CIP':
          return false
          break;
        case 'FAS':
        case 'FOB':
        case 'FCA':
          return true
          break;
      }
    },
    isDestinationPortVisible () {
       switch (this.selectedIncoterms) {
        case 'EXW':
        case 'FCA':
        case 'FAS':
        case 'DPU':
        case 'DAP':
        case 'DDP':
        case 'FOB':
          return false
          break;
        case 'CFR':
        case 'CIF':
        case 'CPT':
        case 'CIP':
          return true
          break;
      }
    },
    dropsLength () {
      if (this.getShipmentResourceDetails != null) {
        return this.getShipmentResourceDetails.drops.length
      }
    }
  },
   watch: {
    // companySearch(value) {
    //   if (value.length > 0) {
    //     this.getOrganizations(value)
    //   }
    // },
    selectedIncoterms: {
      immediate: true,
      handler (val, oldVal) {
        if (val != null && val != oldVal) {
          this.getPorts('')
        }
      }
    }
  },
  methods: {
    ...mapActions({
      setShipmentQuoteRequest: 'setShipmentQuoteRequest',
      setQuoteRequests: 'setQuoteRequests'
    }),
    getOrganizations(query) {
      filterService
        .Organizations({ query: query, pageSize: 5 })
        .then(response => {
          const items = response.items.map((item) => {
            return {
              ...item,
              Description: `${item.name} ${item.ref}`
            }
          })
          this.organizations = this.organizations.concat(items)
        })
    },
    getContacts (id) {
      this.emailInputDisabled = true
      userService.listContacts({ organizationID: id }).then((response) => {
        this.contacts = response.map((contact) => {
          const index = contact.contacts.findIndex(({ type }) => type === 'Email')
          let email = null
          if (index >= 0) {
            email = contact.contacts[index].value
          }
          return {...contact,
          Description: `${contact.name.given} ${contact.name.family}, ${email}`
          }
        })
        this.emailInputDisabled = true
      }).catch((error) => {
        console.error(error)
        this.contacts = []
      }).finally(() => {
        this.emailInputDisabled = false
      })
    },
    async getPorts (item) {
      if (this.selectedTransportType === 'Air') {
        await algoliaService.getPortsForQuoting('airport', item).then((response) => {
         const items = response.map((item) => {
           return {...item,
              Description: `${item.country_code} - ${item.port_name} - ${item.code || ''}`
            }
          })
          switch (this.selectedIncoterms) {
            case 'FCA':
              this.ports = [{ code: 'manual_fill', Description: this.$t('locations.manual_fill') }, ...items]
              break
            default:
              this.ports = [ ...items ]
             break
          }
        })

      } else if (this.selectedTransportType === 'Ocean') {
        await algoliaService.getPortsForQuoting('seaport', item).then((response) => {
          const items = response.map((item) => {
            return {...item,
            Description: `${item.country_code} - ${item.port_name} - ${item.code || ''}`
            }
          })
          switch (this.selectedIncoterms) {
            case 'FCA':
              this.ports = [{ code: 'manual_fill', Description: this.$t('locations.manual_fill') }, ...items]
              break
            default:
              this.ports = [ ...items ]
             break
          }
        // this.ports = items
        })
      }
    },
    handleSelectCompany (item) {
      this.selectedCompany = item
      this.getContacts(this.selectedCompany.id)
      if (this.selectedEmail != null) {
        this.handleAddForwarder()
      }
    },
    handleSelectEmail (item) {
      this.selectedEmail = item
      if (this.selectedCompany != null) {
        this.handleAddForwarder()
      }
    },
    handleSelectTransportType (item) {
      this.selectedTransportType = item.text
    },
    handleSelectIncoterms (item) {
      this.selectedIncoterms = item
    },
    handleSelectOriginPort (item) {
      if (item.code === 'manual_fill') {
        this.isManualAddressVisible = true
      } else {
        if (item.code) {
          this.selectedOriginPort = `${item.port_name} (${item.code})`
        } else {
          this.selectedOriginPort = item.port_name
        }
        this.selectedOriginCoordinates = item._geoloc
      }
    },
    handleSelectDestinationPort (item) {
      if (item.code) {
        this.selectedDestinationPor = `${item.port_name} (${item.code})`
      } else {
        this.selectedDestinationPor = item.port_name
      }
      this.selectedDestinationCoordinates = item._geoloc
    },
    handleSelectOriginManualAddress (address) {
      this.selectedOriginAddress = address
    },
    handleSelectOriginManualCoordinates (coordinates) {
      this.selectedOriginCoordinates = coordinates
    },
    handleCloseManualAddress () {
      this.selectedOriginAddress = null
      this.selectedOriginCoordinates = null
      this.isManualAddressVisible = false
    },
    handleAddForwarder () {
      this.forwardersArray.push({
        id: this.forwarderID,
        company: this.selectedCompany,
        email: this.selectedEmail,
      })
      let email = null
      const contactsIndex = this.selectedEmail.contacts.findIndex(({ type }) => type === 'Email')
      if (contactsIndex >= 0) {
        email = this.selectedEmail.contacts[contactsIndex].value
      }
      this.quoteArray.push({
        organizationID: this.selectedCompany.id,
        contactID: this.selectedEmail.id,
        email
      })
      this.selectedCompany = null
      this.selectedEmail = null
      this.emailInputDisabled = true
      this.forwarderID = uuid.v4()
    },
    handleEmptyForwarder () {
      this.selectedCompany = null
      this.selectedEmail = null
      this.selectedTransportType = null
      this.selectedIncoterms = null
      this.selectedOriginPort = null
      this.selectedDestinationPort = null
      this.selectedOriginAddress = null
      this.selectedDestinationAddress = null
      this.selectedOriginCoordinates = null
      this.selectedDestinationCoordinates = null
      this.forwarderID = uuid.v4()
      this.isManualAddressVisible = false
      this.transportTypeKey = uuid.v1()
    },
    handleRemoveForwader (index) {
      this.forwardersArray.splice(index, 1)
      this.quoteArray.splice(index, 1)
    },
    handleSaveForm () {
      this.dialog = false
      this.forwardersArray.forEach((quote, index) => {
        this.request.push({
          quoteID: null,
          organization: quote.company,
          contact: quote.email,
          email: this.quoteArray[index].email,
          price: null,
          currency: null,
          pricingCommnent: null,
          requestComment: this.quoteRequestMessage,
          status: 'Requested',
          createdAt: moment().valueOf(),
          quotedAt: null,
          acceptedAt: null,
          withdrawnAt: null,
          rejectedAt: null,
          canceledAt: null,
          transportType: this.selectedTransportType,
          incoterms: this.selectedIncoterms,
          originPort: this.selectedOriginPort,
          originAddress: this.selectedOriginAddress,
          originCoordinates: this.selectedOriginCoordinates,
          destinationPort: this.selectedDestinationPort,
          destinationAddress: this.selectedDestinationAddress,
          destinationCoordinates: this.selectedDestinationCoordinates
        })
      })
      this.setQuoteRequests({
        shipmentID: this.$route.params.shipmentID,
        comment: this.quoteRequestMessage,
        transportType: this.selectedTransportType,
        incoterms: this.selectedIncoterms,
        originPort: this.selectedOriginPort,
        originAddress: this.selectedOriginAddress,
        originCoordinates: this.selectedOriginCoordinates,
        destinationPort: this.selectedDestinationPort,
        destinationAddress: this.selectedDestinationAddress,
        destinationCoordinates: this.selectedDestinationCoordinates,
        requests: this.quoteArray,
        requestObject: this.request
      })
      this.forwardersArray = []
      this.request = []
      this.quoteArray = []
      this.quoteRequestMessage = ''
      this.selectedTransportType = null
      this.selectedIncoterms = null
      this.selectedOriginPort = null
      this.selectedDestinationPort = null
      this.selectedOriginAddress = null
      this.selectedDestinationAddress = null
      this.selectedOriginCoordinates = null
      this.selectedDestinationCoordinates = null
      this.handleEmptyForwarder()
    },
    handleCancelForm () {
      this.forwardersArray = []
      this.quoteRequestMessage = ''
      this.handleEmptyForwarder()
      this.dialog = false
    },
    handleIconPortType (type) {
      switch (type) {
        case 'seaport':
          return 'fas fa-ship'
        case 'airport':
          return 'fas fa-plane'
        default:
          return null
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .quoting--forwarder-list {
    // .incoterms {
    //   margin-left: 75px;
    // }
    // margin-bottom: 10px;
    width: 100%;
    .flex--layout {
      display: flex;
      &.column {
        flex-direction: column;
        .flex--50 {
          &:nth-child(odd) {
            margin-right: 30px;
          }
        }
        .flex--40 {
          &:nth-child(odd) {
            margin-right: 10%;
          }
        }
      }
      &.row {
        // margin-bottom: 5px;
        flex-direction: row;
        .flex--50 {
          &:nth-child(odd) {
            margin-right: 30px;
          }
        }
        .flex--40 {
          &:nth-child(odd) {
            margin-right: 10%;
          }
        }
      }
      .flex--50 {
        flex: 1 1 50%;
        max-width: 50%;
      }
      .flex--25 {
        flex: 1 1 25%;
        max-width: 25%;
      }
      .flex--40 {
        flex: 1 1 40%;
        max-width: 40%;
      }
      .flex--10 {
        flex: 1 1 10%;
        max-width: 10%;
      }
      .flex--max-content {
        flex: 1 1 max-content;
      }
      .flex--auto {
        flex: 1 1 auto;
      }
      .flex--100 {
        flex: 1 1 100%;
        max-width: 100%;
      }
    }
      .div--forwader--values {
        width: 100%;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        -moz-border-radius: 0;
        -webkit-border-radius: 0;
        outline: none;
        border: 1px solid #e3e3e3;
        border-radius: 4px;
        background-color: transparent;
        font-family: inherit;
        color: #767676;
        min-height: 25px;
        font-size: 14px;
        padding-left: 10px;
        margin-bottom: 18px;
        &.last-list-item {
          margin-bottom: 0px !important;
        }
        position: relative;
        .top--placeholder {
          font-size: 10px;
          font-weight: 500;
          position: absolute;
          top: -20px;
          left: 0;
        }
    }
  }
  .quoting--card--form {
    .flex--layout {
      display: flex;
      &.column {
        flex-direction: column;
      }
      &.row {
        flex-direction: row;
        .flex--50 {
          &:nth-child(odd) {
            margin-right: 30px;
          }
        }
      }
    }
    width: 100%;
    .flex--50 {
      flex: 1 1 50%;
      max-width: 50%;
    }
    .flex--25 {
      flex: 1 1 25%;
      max-width: 25%;
    }
    .flex--40 {
        flex: 1 1 40%;
        max-width: 40%;
      }
    .flex--100 {
      flex: 1 1 100%;
      max-width: 100%;
    }
    .flex--max-content {
      flex: 1 1 max-content;
    }
    .quoting--textarea--message {
      margin-top: 10px;
      span {
        font-weight: 500;
        font-size: 12px;
        color: #767676;
      }
      textarea {
        width: 100%;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        -moz-border-radius: 0;
        -webkit-border-radius: 0;
        outline: none;
        border: 1px solid #e3e3e3;
        border-radius: 4px;
        background-color: transparent;
        font-family: inherit;
        color: #767676;
        min-height: 25px;
        font-size: 18px;
        padding-left: 10px;
        &::placeholder {
          color: #e3e3e3;
        }
      }
    }
  }
</style>
